import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Contextone } from './Context';
import { fetchBookmark } from './Api';
import staticLogo from "../images/mahuadesi.png"
import Cookies from 'js-cookie';
import chullLogo from '../images/chullLogo.png';
import chullLogoLandscape from '../images/chullLandscape_resize.png';
import sidesLogoLandscape from '../images/4sidesLogoLandscape.png';
import subscribe from '../images/premium.png';
import rentIcon from '../images/rentIcon.png';
// import globalSetting from "../configuration.js";

// Shimmer effect components
const ShimmerContainer = styled.div`
  height: 230px;
  width: 178px;
  margin: 0 10px 30px 0;
  background: #3a3a3a;
  background-image: linear-gradient(to right, #3a3a3a 0%, #3f3f3f 10%, #4a4a4a 20%, #3f3f3f 30%, #3a3a3a 50%, #3a3a3a 100%);
  background-repeat: no-repeat;
  background-size: 1900px 800px;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: ease-in-out;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

const ShimmerRow = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', marginTop: '15vh' }}>
        {[...Array(14)].map((_, index) => (
            <ShimmerContainer key={index} />
        ))}
    </div>
);

const WatchList = ({ match }) => {
    const { id } = match.params;
    const [videos, setvid] = useState([]);
    const [tvdata, setTvData] = useState([]);
    const [loading, setLoading] = useState(false);
    const host = window.location.host;
    const countercontext = useContext(Contextone);
    const isurl = countercontext.isDomain;
    const apiUrl = `https://${isurl}`;
    let logo = countercontext.isLogo;
    let LandscapeLogo = countercontext.isLogo;
    const uid = Cookies.get('userid');

    if(logo == 'https://ottimages.b-cdn.net/mahuaplay/images/avatar/I07Yh344sEwgLuFiobbKXSjLTN637JuyX4rjsUqt.png'){
        logo = staticLogo
      }

    const addDefaultImg = ev => {
        ev.target.src = logo;
     }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = await fetchBookmark(apiUrl,uid);
                let vid = data.result;
                // let tv = data.tvshow;
                // setTvData(tv);
                setvid(vid);
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const slugify = (text) => {
        return text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
      };
      
      const decodeVal = (str) => {
        return btoa(str);
      }
      
      const createEncodedData = (id, type_id, video_type, upcoming_type) => {
        const str = `${id}-${type_id}-${video_type}-${upcoming_type}`; 
        return decodeVal(str); 
      };

    if(apiUrl == "https://chull.ottsnap.in"){
        logo = chullLogo;
        LandscapeLogo = chullLogoLandscape;
    }

    if(apiUrl == "https://4sides.ottsnap.in"){
        LandscapeLogo = sidesLogoLandscape;
    }

    return (
        <>
            <div>
                {loading ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <ShimmerRow />
                    </div>
                ) : (
                    <div className="view-list">
                        {videos.length === 0  ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh', color: 'white' }}>
                                <h2>No data available</h2>
                            </div>
                        ) : (
                            <>
                                {videos.length > 0 && (
                                    <div className='view-screen'>
                                        <h4 className="movie-heading" style={{marginBottom:'5px'}}> Movies </h4>
                                        {videos.map((movie, key) => (
                                            <div className="custom-div" key={key}>
                                                {movie.is_live_url ? (
                                                    <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>
                                                    {isurl == '4sides.ottsnap.in' && (
                                                    movie.landscape ? (
                                                        <img src={movie.landscape} 
                                                        onError={addDefaultImg}
                                                        className="img-top" alt={movie.name} loading="lazy" />
                                                    ) : movie.landscape_1 ? (
                                                        <img src={movie.landscape_1} 
                                                        onError={addDefaultImg}
                                                        className="img-top" alt={movie.name} loading="lazy" />
                                                    ): (
                                                        <img src={LandscapeLogo} className="img-top" alt="..." loading="lazy" />
                                                    )
                                                   )}
                                                   {isurl == 'chull.ottsnap.in' && (
                                                    movie.thumbnail_1 ? (
                                                        <img src={movie.thumbnail_1} 
                                                        onError={addDefaultImg}
                                                        className="img-top" alt={movie.name} loading="lazy" />
                                                    ) : movie.thumbnail ? (
                                                        <img src={movie.thumbnail} 
                                                        onError={addDefaultImg}
                                                        className="img-top" alt={movie.name} loading="lazy" />
                                                    ):(
                                                        <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                    )
                                                   )}
                                                </Link>
                                                ):(
                                                    <Link to={`/watchlist/${slugify(movie.name)}/${createEncodedData(movie.id,movie.type_id, movie.video_type, movie.upcoming_type)}`}>
                                                    {(movie.is_premium || movie.is_rent !== 0) && (
                                                        <img
                                                            src={movie.is_premium ? subscribe : rentIcon}
                                                            className={`premium-img ${movie.is_premium ? 'premium-style' : ''}`}
                                                            alt="Premium/Rent Icon"
                                                        />
                                                    )}
                                                   {isurl == '4sides.ottsnap.in' && (
                                                    movie.landscape ? (
                                                        <img src={movie.landscape} 
                                                        onError={addDefaultImg}
                                                        className="img-top" alt={movie.name} loading="lazy" />
                                                    ) : movie.landscape_1 ? (
                                                        <img src={movie.landscape_1} 
                                                        onError={addDefaultImg}
                                                        className="img-top" alt={movie.name} loading="lazy" />
                                                    ): (
                                                        <img src={LandscapeLogo} className="img-top" alt="..." loading="lazy" />
                                                    )
                                                   )}
                                                   {isurl == 'chull.ottsnap.in' && (
                                                    movie.thumbnail_1 ? (
                                                        <img src={movie.thumbnail_1} 
                                                        onError={addDefaultImg}
                                                        className="img-top" alt={movie.name} loading="lazy" />
                                                    ) : movie.thumbnail ? (
                                                        <img src={movie.thumbnail} 
                                                        onError={addDefaultImg}
                                                        className="img-top" alt={movie.name} loading="lazy" />
                                                    ):(
                                                        <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                    )
                                                   )}
                                                </Link>
                                                )}
                                                    
                                            </div>
                                        ))}
                                    </div>
                                )}
                                
                            </>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default WatchList;